import { makeStyles } from "@material-ui/core/styles";
import blog from "../../images/blog.jpg";

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 20,
    margin: "30px 0",
    padding: "10px 10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(${blog})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    boxShadow: "10px 10px 40px rgba(0, 0, 0, 0.25)",
  },
  heading: {
    color: "white",
    fontWeight: 600,
  },
  image: {
    marginLeft: "15px",
  },
  // this works like a media query for Material
  [theme.breakpoints.down("sm")]: {
    mainContainer: {
      flexDirection: "column-reverse",
    },
  },
  appBarSearch: {
    borderRadius: 10,
    marginBottom: "1rem",
    display: "flex",
    padding: "16px",
  },
  pagination: {
    borderRadius: 30,
    marginTop: "1rem",
    padding: "16px",
  },
  gridContainer: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  endAdornment: {
    color: "#677f92",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    fontFamily: "merriweather",
    "&:hover": {
      webkitTransform: "translate(10px, -10px)",
      msTransform: "translate(8px, -6px)",
      transform: "translate(3px, -3px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      color: "#22A86A",
    },
  },
  buttonSubmit: {
    marginTop: 15,
    marginBottom: 15,
    fontWeight: 500,
    background: "linear-gradient(45deg, #343D48 30%, #366994 90%)",
    border: 0,
    borderRadius: 3,
    boxShadow: "5px 10px 10px rgba(0, 0, 0, 0.25)",
    color: "white",
    height: 48,
    padding: "0 30px",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    "&:hover": {
      webkitTransform: "translate(6px, -6px)",
      msTransform: "translate(6px, -6px)",
      transform: "translate(3px, -3px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      fontWeight: 600,
    },
  },
}));
